<template>
  <div class="pc-lecture-coopration">
    <h2>合作信息管理</h2>
    <El-button v-if="!isEditting" @click="isEditting = true" class="edit-btn"
      >编辑</El-button
    >
    <El-button v-if="isEditting" @click="isEditting = false" class="edit-btn"
      >完成</El-button
    >
    <div class="content-list">
      <div v-for="item in srcList" :key="item.id" class="content-item">
        <h2 v-if="item.group" class="type">
          {{ item.group.chinese_name }}
          <span
            class="el-icon-plus"
            v-if="isEditting"
            @click="
              () => {
                dialogVisible = true;
                infoArgs.type = item.group;
              }
            "
          ></span>
        </h2>
        <div
          v-for="content in item.content"
          :key="content.id"
          class="type-item"
        >
          <p class="el-icon-edit" @click="edit(content)" v-if="isEditting"></p>
          <p
            class="el-icon-circle-close"
            @click="deleteShow(content)"
            v-if="isEditting"
          ></p>
          <p class="second" v-if="content.main_key">
            <span>二级:</span>
            {{ content.main_key }}
          </p>
          <p class="third" v-if="content.sub_key">
            <span>三级:</span>
            {{ content.sub_key }}
          </p>
          <p class="link">
            <span>链接:</span>
            {{ content.src ? content.src : "暂无" }}
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      class="pc-dialog"
      :close-on-click-modal="false"
    >
      <div class="content">
        <h4 class="title">{{ infoArgs.type.chinese_name }}</h4>
        <div class="input-item">
          <p>二级名称:</p>
          <el-input
            v-model="infoArgs.main_key"
            placeholder="请输入一级名称"
          ></el-input>
        </div>
        <div
          class="input-item"
          v-if="infoArgs.type.id != 1 && infoArgs.type.id != 2"
        >
          <p>三级名称:</p>
          <el-input
            v-model="infoArgs.sub_key"
            placeholder="请输入二级名称"
          ></el-input>
        </div>
        <div class="input-item">
          <p>链接:</p>
          <el-input v-model="infoArgs.src" placeholder="请输入链接"></el-input>
        </div>

        <button class="btncancel" @click="closeDialog">取消</button>
        <button class="btnadd" @click="comfirm">确定</button>
      </div>
    </el-dialog>
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";

import {
  getHeritageSrcType,
  getHeritageSrc,
  updateHeritageSrc,
  createHeritageSrc,
  deleteHeritageSrc,
} from "@/apis/heritage.api";

export default {
  data() {
    return {
      infoArgs: {
        main_key: "",
        sub_key: "",
        src: "",
        type_id: "",
        type: null,
      },
      isEditting: false,
      dialogVisible: false,
      deleteDialogVisible: false,
      srcList: [],
    };
  },
  mounted() {
    this.getHeritageSrc();
    // getHeritageSrcType().then((res) => {
    //   console.log(res.data);
    // });
  },
  components: {
    DeleteDialog,
  },
  methods: {
    edit(content) {
      this.dialogVisible = true;
      this.infoArgs = { ...content };
      console.log(this.infoArgs);
    },
    comfirm() {
      // createHeritageSrc()
      this.infoArgs.type_id = this.infoArgs.type.id;

      if (this.infoArgs.id) {
        this.infoArgs.src_id = this.infoArgs.id;
        updateHeritageSrc(this.infoArgs).then((res) => {
          if (res.code == 205) {
            this.closeDialog();
            this.$global.success(this, "修改成功");
            this.getHeritageSrc();
          } else {
            this.closeDialog();
            this.$global.error(this, "修改失败");
          }
        });
      } else {
        createHeritageSrc(this.infoArgs).then((res) => {
          if (res.code == 205) {
            this.closeDialog();
            this.$global.success(this, "添加成功");
            this.getHeritageSrc();
          } else {
            this.closeDialog();
            this.$global.error(this, "添加失败");
          }
          console.log(res.data);
        });
      }
      console.log(this.infoArgs);
    },
    getHeritageSrc() {
      getHeritageSrc().then((res) => {
        let srcList = res.data;
        this.srcList = [];
        for (let key in srcList) {
          console.log(srcList[key][0]);
          this.srcList.push({
            group: srcList[key][0].type,
            content: srcList[key],
          });
        }

        console.log(this.srcList);
      });
    },

    deleteConfirm() {
      console.log(this.infoArgs);
      let src_id = this.infoArgs.id;
      if (src_id) {
        deleteHeritageSrc({ src_id: src_id })
          .then((res) => {
            if (res.code == 205) {
              this.$global.success(this, "删除成功");
              this.getHeritageSrc();
              this.deleteDialogVisible = false;
            }
          })
          .catch(() => {
            this.$global.error(this, "删除失败, 请重试");
          });
      } else {
        this.$global.error(this, "删除失败, 请重试");
      }
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    deleteShow(content) {
      this.infoArgs = { ...content };
      this.deleteDialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.infoArgs = {
        main_key: "",
        sub_key: "",
        src: "",
        type_id: "",
        type: null,
      };
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-lecture-coopration {
  @include box-model;
  .edit-btn {
    @include manage-button;
    position: absolute;
    top: 20px;
    right: 30px;
  }
  .content-list {
    .content-item {
      margin-bottom: 20px;
      .type {
        margin-bottom: 20px;
        span {
          border: 1px dotted $timeBtn;
          color: $timeBtn;
          cursor: pointer;
        }
        span:hover {
          border: none;
          background: $timeBtn;
          color: white;
        }
      }
      .type-item {
        line-height: 30px;
        display: flex;
        p {
          span {
            color: $lightenYellow;
          }
        }
        .el-icon-edit {
          width: 20px;
          color: $timeBtn;
          line-height: 30px;
          cursor: pointer;
        }
        .el-icon-circle-close {
          width: 20px;
          line-height: 30px;
          color: $timeBtn;
          cursor: pointer;
        }
        .second {
          width: 30%;
          @include ellipsis;
          margin-right: 10px;
        }
        .third {
          width: 30%;
          @include ellipsis;
          margin-right: 10px;
        }
        .link {
          @include ellipsis;
        }
      }
    }
  }

  .pc-dialog {
    // .buttonBox {
    //   display: flex;
    //   justify-content: space-evenly;
    // }

    /deep/ .el-form-item__label {
      white-space: nowrap;
    }
    /deep/ .el-dialog {
      width: 800px;
      min-height: 210px;
    }
    /deep/ .el-icon-close {
      display: none;
    }
    /deep/ .el-dialog__header {
      display: none;
    }
    /deep/ .el-dialog__body {
      padding: 30px 30px;
      height: 100%;
      position: relative;
      .content {
        margin-bottom: 20px;
        position: relative;
        height: 300px;
        .title {
          margin: 10px 30px 0 0;
          font-family: $chinese;
          font-size: 24px;
          font-weight: bold;
          color: #000000;
        }
        .el-input {
          width: 70%;
        }
        .input-item {
          display: flex;
          margin-top: 30px;
          p {
            width: 90px;
            text-align: right;
            font-weight: bold;
            margin-right: 20px;
            line-height: 30px;
          }
        }
      }

      .btncancel,
      .btnadd {
        position: absolute;
        margin-top: 20px;
        right: 0px;
        bottom: 0px;
        cursor: pointer;
        width: 77px;
        height: 30px;
        border-radius: 4px;
        font-family: $chinese;
        font-size: 12px;
        color: #5a5e66;
        &:hover {
          filter: brightness(105%);
        }
      }
      .btncancel {
        right: 100px;
        border: 1px solid #dcdfe6;
        background: white;
        color: #5a5e66;
      }
      .btnadd {
        border: 1px solid #5470c6;
        background: #5470c6;
        color: white;
      }
      /deep/ .input.el-input__inner {
        width: 269px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/iHeritage/components/CooperationManagement.vue